import React, { useState } from "react";
import { motion } from "framer-motion";
import { Lock, ArrowRight } from "lucide-react";
import { ACCESS_CODE, GATE } from "./data";

export default function Gate({ onUnlock }) {
  const [code, setCode] = useState("");
  const [error, setError] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (code.trim().toUpperCase() === ACCESS_CODE) {
      sessionStorage.setItem("sl_access", "1");
      onUnlock();
    } else {
      setError(true);
    }
  };

  return (
    <div className="gate-root" data-testid="gate-root">
      <motion.form
        className="gate-card"
        onSubmit={submit}
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      >
        <div className="gate-lock">
          <Lock size={20} strokeWidth={1.5} />
        </div>
        <h1 className="gate-title">{GATE.title}</h1>
        <p className="gate-subtitle">
          {GATE.subtitle.it} · {GATE.subtitle.en}
        </p>
        <div className="gate-rule" />
        <label className="gate-prompt" htmlFor="gate-code">
          {GATE.prompt.it} / {GATE.prompt.en}
        </label>
        <input
          id="gate-code"
          type="password"
          className={`gate-input ${error ? "gate-input-error" : ""}`}
          value={code}
          onChange={(e) => {
            setCode(e.target.value);
            setError(false);
          }}
          placeholder={GATE.placeholder.it}
          autoFocus
          data-testid="gate-code-input"
        />
        {error && (
          <p className="gate-error" data-testid="gate-error">
            {GATE.error.it} · {GATE.error.en}
          </p>
        )}
        <button type="submit" className="gate-submit" data-testid="gate-submit-btn">
          {GATE.submit.it} <ArrowRight size={16} />
        </button>
      </motion.form>
    </div>
  );
}
